import $ from 'jquery';
import slick from 'slick-carousel';
import * as CONST from '../../common/utils/constants';
import Util from '../../common/utils/ui'; 

class Carousel {
    constructor(target, settings) {
        
    }

    init() {
        if (Util.getViewPort() !== CONST.ViewPort.Desktop && !$('.collage-carousel-images').hasClass('slick-initialized')) {
            this.collageCarousel();
        }

        $(window).resize(() => {
          if (Util.getViewPort() !== CONST.ViewPort.Desktop && !$('.collage-carousel-images').hasClass('slick-initialized')) {
                this.collageCarousel();
            }
        });
    }

    collageCarousel() {
        if ($('.collage-carousel-images').length) {
            $('.collage-carousel-images').slick({
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: true,
                arrows: false,
                responsive: [
                    {
                      breakpoint: 992,
                      settings: 'unslick'
                    }
                ]
            });
        }
    }
}

export default Carousel;

$(() => {
	const carousel = new Carousel();
	carousel.init();
});